import { inject, injectable } from '@theia/core/shared/inversify';
import { FrontendApplicationContribution } from '@theia/core/lib/browser';
import { IframeListenerService } from './iframe-listener-service';

@injectable()
export class RenesasFrontendApplication implements FrontendApplicationContribution {
    constructor(
        @inject(IframeListenerService) protected iframeListenerService: IframeListenerService) {
    }

    async onStart(): Promise<void> {
        return Promise.resolve()
    }
}